var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Box, Divider, IconButton, MenuItem, Select, Switch, Tooltip } from "@mui/material";
import FormatAlignLeftRoundedIcon from "@mui/icons-material/FormatAlignLeftRounded";
import FormatAlignRightRoundedIcon from "@mui/icons-material/FormatAlignRightRounded";
import FormatAlignCenterRoundedIcon from "@mui/icons-material/FormatAlignCenterRounded";
import FormatBoldRoundedIcon from "@mui/icons-material/FormatBoldRounded";
import FormatUnderlinedRoundedIcon from "@mui/icons-material/FormatUnderlinedRounded";
import FormatItalicRoundedIcon from "@mui/icons-material/FormatItalicRounded";
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import FormatListNumberedRoundedIcon from "@mui/icons-material/FormatListNumberedRounded";
import AddPhotoAlternateRoundedIcon from "@mui/icons-material/ImageRounded";
import VideoCameraBackRoundedIcon from "@mui/icons-material/VideoCameraBackRounded";
import AudioFileRoundedIcon from "@mui/icons-material/AudioFileRounded";
import $ from "jquery";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
var SelectedAlignOption;
(function (SelectedAlignOption) {
    SelectedAlignOption[SelectedAlignOption["LEFT"] = 0] = "LEFT";
    SelectedAlignOption[SelectedAlignOption["MIDDLE"] = 1] = "MIDDLE";
    SelectedAlignOption[SelectedAlignOption["RIGHT"] = 2] = "RIGHT";
})(SelectedAlignOption || (SelectedAlignOption = {}));
var SelectedTextFormatOption;
(function (SelectedTextFormatOption) {
    SelectedTextFormatOption[SelectedTextFormatOption["BOLD"] = 0] = "BOLD";
    SelectedTextFormatOption[SelectedTextFormatOption["ITALIC"] = 1] = "ITALIC";
    SelectedTextFormatOption[SelectedTextFormatOption["UNDERLINE"] = 2] = "UNDERLINE";
})(SelectedTextFormatOption || (SelectedTextFormatOption = {}));
var SelectedListOption;
(function (SelectedListOption) {
    SelectedListOption[SelectedListOption["UNORDERED"] = 0] = "UNORDERED";
    SelectedListOption[SelectedListOption["ORDERED"] = 1] = "ORDERED";
})(SelectedListOption || (SelectedListOption = {}));
export var ImageResizeMode;
(function (ImageResizeMode) {
    ImageResizeMode[ImageResizeMode["GHOST"] = 0] = "GHOST";
    ImageResizeMode[ImageResizeMode["NORMAL"] = 1] = "NORMAL";
})(ImageResizeMode || (ImageResizeMode = {}));
export function htmlToSource(selector) {
    return $("<div />").append($(selector).clone()).html();
}
function loseFocusToMessageBox() {
    var _a;
    (_a = document.getElementById("rich-text-editor")) === null || _a === void 0 ? void 0 : _a.blur();
}
function modifyText(commandName, val) {
    return document.execCommand(commandName, false, val);
}
export var DragContentOptions;
(function (DragContentOptions) {
    DragContentOptions["IMAGE"] = "images";
    DragContentOptions["IMAGE_360"] = "three_sixty_image";
    DragContentOptions["AUDIO"] = "audio";
    DragContentOptions["VIDEO"] = "video";
    DragContentOptions["VIDEO_360"] = "three_sixty_video";
    DragContentOptions["MODEL_3D"] = "three_d_model";
    DragContentOptions["MOVEMENT"] = "movement";
    DragContentOptions["INFORMATION"] = "information";
    DragContentOptions["ANSWER"] = "answer";
    DragContentOptions["QUESTION"] = "question";
    DragContentOptions["INTERFACE"] = "interface";
    DragContentOptions["SCENE"] = "scene";
})(DragContentOptions || (DragContentOptions = {}));
export function VTRichTextEditorControls(_a) {
    // const [htmlVal, setHtmlVal] = useState<string>(startingHtmlContent);
    //   const [fontSize, setFontSize] = useState<number>(4);
    var rteId = _a.rteId, sx = _a.sx, onClickImageIcon = _a.onClickImageIcon, onClickVideoIcon = _a.onClickVideoIcon, onClickAudioIcon = _a.onClickAudioIcon, _b = _a.focusOnMount, focusOnMount = _b === void 0 ? false : _b, onChange = _a.onChange, save = _a.save, cancel = _a.cancel;
    var _c = __read(useState(4), 2), fontSize = _c[0], setFontSize = _c[1];
    var _d = __read(useState(null), 2), selectedAlignButtonOption = _d[0], setSelectedAlignButtonOption = _d[1];
    var _e = __read(useState(null), 2), selectedFormatOption = _e[0], setSelectedFormatOption = _e[1];
    var _f = __read(useState(null), 2), selectedListOption = _f[0], setSelectedListOption = _f[1];
    var _g = __read(useState(false), 2), fontSizeToolTipOpen = _g[0], setFontSizeToolTipOpen = _g[1];
    var _h = __read(useState(true), 2), rawHTMLToggleChecked = _h[0], setRawHTMLToggleChecked = _h[1];
    var currentSelectedImgIdRef = useRef(null);
    var imgIdsRef = useRef(null);
    var mouseOverContentEditableAreaRef = useRef(false);
    var _j = __read(useState(false), 2), imgIsCurrentlySelected = _j[0], setImgIsCurrentlySelected = _j[1];
    function setFocusToMessageBox() {
        if (rteId) {
            // @ts-ignore
            document.getElementById(rteId).focus();
        }
    }
    var _k = __read(useState(40), 2), buttonsPxSize = _k[0], setButtonsPxSize = _k[1];
    var rteContainerRef = useRef(null);
    function resizeButtons() {
        var _a;
        // @ts-ignore
        var containerWidth = (_a = rteContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        if (containerWidth) {
            if (containerWidth <= 505) {
                setButtonsPxSize(25);
            }
            else if (containerWidth <= 550) {
                setButtonsPxSize(30);
            }
            else if (containerWidth <= 600) {
                setButtonsPxSize(35);
            }
            else {
                setButtonsPxSize(40);
            }
        }
    }
    useEffect(function () {
        rteContainerRef.current = document.getElementById("rich-text-editor-container");
        if (rteContainerRef.current) {
            resizeButtons();
            new ResizeObserver(resizeButtons).observe(rteContainerRef.current);
        }
    }, []);
    return (_jsx(Box, __assign({ id: "rich-text-editor-container", component: "div", sx: __assign({ height: "50px", borderRadius: "15px", background: "#333" }, sx), onInput: function (e) {
            // console.log("MOST OUTER INPUT FIRED");
        } }, { children: _jsxs(Box, __assign({ component: "div", sx: { display: "flex", justifyContent: "space-between" } }, { children: [_jsxs(Box, __assign({ component: "div", sx: { display: "flex", alignItems: "center", padding: "5px" } }, { children: [_jsx(Tooltip, __assign({ open: fontSizeToolTipOpen, arrow: true, title: "Font Size" }, { children: _jsx(Select, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, onOpen: function () {
                                    setFontSizeToolTipOpen(false);
                                    setFocusToMessageBox();
                                }, onMouseEnter: function () {
                                    setFontSizeToolTipOpen(true);
                                }, onMouseLeave: function () {
                                    setFontSizeToolTipOpen(false);
                                }, sx: {
                                    height: "".concat(buttonsPxSize, "px"),
                                    marginRight: "8px",
                                }, labelId: "fontsize-select-label", id: "fontsize-select", value: fontSize, label: "fontsize", onChange: function (event) {
                                    var n = event.target.value;
                                    modifyText("fontSize", n);
                                    setFontSize(n);
                                } }, { children: Array.from({ length: 7 }, function (_, i) { return i + 1; }).map(function (i) { return (_jsx(MenuItem, __assign({ value: i }, { children: i }))); }) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Bold Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.BOLD && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                //   action={}
                                onClick: function (e) {
                                    modifyText("bold");
                                    setFocusToMessageBox();
                                } }, { children: _jsx(FormatBoldRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Italic Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.ITALIC && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                //   action={}
                                onClick: function () {
                                    modifyText("italic");
                                    setFocusToMessageBox();
                                } }, { children: _jsx(FormatItalicRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Underline Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.UNDERLINE && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                //   action={}
                                onClick: function () {
                                    modifyText("underline");
                                    setFocusToMessageBox();
                                } }, { children: _jsx(FormatUnderlinedRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Left" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.LEFT && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                //   action={}
                                onClick: function (e) {
                                    setSelectedAlignButtonOption(SelectedAlignOption.LEFT);
                                    if (currentSelectedImgIdRef.current) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        var $selector = $("#" + currentSelectedImgIdRef.current);
                                        // if($selector.parent.
                                        if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                            $selector.parent().parent().css({ textAlign: "left" });
                                        }
                                        else {
                                            $selector.parent().wrap("<div style=\"text-align: left;\"> </div>");
                                        }
                                    }
                                    else {
                                        modifyText("justifyLeft");
                                        setFocusToMessageBox();
                                    }
                                } }, { children: _jsx(FormatAlignLeftRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Middle" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.MIDDLE && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function (e) {
                                    setSelectedAlignButtonOption(SelectedAlignOption.MIDDLE);
                                    if (currentSelectedImgIdRef.current) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        var $selector = $("#" + currentSelectedImgIdRef.current);
                                        // if($selector.parent.
                                        if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                            $selector.parent().parent().css({ textAlign: "center" });
                                        }
                                        else {
                                            $selector.parent().wrap("<div style=\"text-align: center;\"> </div>");
                                        }
                                    }
                                    else {
                                        modifyText("justifyCenter");
                                        setFocusToMessageBox();
                                    }
                                } }, { children: _jsx(FormatAlignCenterRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Right" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.RIGHT && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function (e) {
                                    setSelectedAlignButtonOption(SelectedAlignOption.RIGHT);
                                    if (currentSelectedImgIdRef.current) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        var $selector = $("#" + currentSelectedImgIdRef.current);
                                        // if($selector.parent.
                                        if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                            $selector.parent().parent().css({ textAlign: "right" });
                                        }
                                        else {
                                            $selector.parent().wrap("<div style=\"text-align: right;\"> </div>");
                                        }
                                    }
                                    else {
                                        modifyText("justifyRight");
                                        setFocusToMessageBox();
                                    }
                                } }, { children: _jsx(FormatAlignRightRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Unordered List" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedListOption === SelectedListOption.UNORDERED && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                //   action={}
                                onClick: function () {
                                    modifyText("insertUnorderedList");
                                    setFocusToMessageBox();
                                } }, { children: _jsx(FormatListBulletedRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Ordered List" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedListOption === SelectedListOption.ORDERED && {
                                    backgroundColor: "#4f029c",
                                })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function () {
                                    modifyText("insertOrderedList");
                                    setFocusToMessageBox();
                                } }, { children: _jsx(FormatListNumberedRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Add Image" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, id: "add-image", sx: {
                                    borderRadius: "3px",
                                    marginRight: "4px",
                                    width: "".concat(buttonsPxSize, "px"),
                                    height: "".concat(buttonsPxSize, "px"),
                                }, onClick: function (e) {
                                    e.stopPropagation();
                                    // const imgId = "I_" + Math.floor(Math.random() * 100000);
                                    // if (imgIdsRef.current == null) imgIdsRef.current = [];
                                    // imgIdsRef.current.push(imgId);
                                    // let imgHTMLstr = `<img class="rte-image" id="${imgId}" width="150" height="100" src="${"https://virtus-ninja-dev.s3.eu-west-1.amazonaws.com/wales_virtual_hospital/images/68cd9255-3967-4ef5-8394-093436ad09ec.png"}" />`;
                                    // modifyText("insertHTML", imgHTMLstr);
                                    onClickImageIcon && onClickImageIcon();
                                } }, { children: _jsx(AddPhotoAlternateRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Add Video" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, 
                                // disabled={true}
                                id: "add-video", sx: {
                                    borderRadius: "3px",
                                    marginRight: "4px",
                                    width: "".concat(buttonsPxSize, "px"),
                                    height: "".concat(buttonsPxSize, "px"),
                                }, onClick: function (e) {
                                    //                 e.stopPropagation();
                                    //                 const imgId =
                                    //                     "I_" + Math.floor(Math.random() * 100000);
                                    //                 if (imgIdsRef.current == null)
                                    //                     imgIdsRef.current = [];
                                    //                 imgIdsRef.current.push(imgId);
                                    //                 // width="320" height="240"
                                    // let videoHTMLStr = `<span> </span> <video width="300" height="240" controls>
                                    //   <source
                                    //     src="${"https://virtus-tech-bls-media-dev.s3.eu-west-1.amazonaws.com/videos/scenario_3_shock.mp4"}"
                                    //     type="video/mp4">
                                    //   Your browser does not support the video tag.
                                    // </video>`;
                                    //                 // let imgHTMLstr = `<img class="rte-image" id="${imgId}" src="${
                                    //                 //   process.env.PUBLIC_URL + "/images/Default.png"
                                    //                 // }" style="cursor: move;"/>`;
                                    // modifyText("insertHTML", videoHTMLStr);
                                    onClickVideoIcon && onClickVideoIcon();
                                } }, { children: _jsx(VideoCameraBackRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Add Audio" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, 
                                // disabled={true}
                                id: "add-audio", sx: {
                                    borderRadius: "3px",
                                    marginRight: "4px",
                                    width: "".concat(buttonsPxSize, "px"),
                                    height: "".concat(buttonsPxSize, "px"),
                                }, onClick: function (e) {
                                    onClickAudioIcon && onClickAudioIcon();
                                } }, { children: _jsx(AudioFileRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Box, __assign({ component: "div", sx: { marginLeft: "-19px" } }, { children: _jsx(Tooltip, __assign({ arrow: true, title: rawHTMLToggleChecked ? "Edit Raw HTML" : "Edit Content" }, { children: _jsx(Switch, { disabled: imgIsCurrentlySelected, sx: { transform: "rotate(90deg)" }, onChange: function (event) {
                                        // setRawHtml(encodeCharacterEscapedHTML(editAreaRef.current!.innerHTML));
                                        setRawHTMLToggleChecked(event.target.checked);
                                    }, checked: rawHTMLToggleChecked }) })) }))] })), _jsxs(Box, __assign({ component: "div", sx: { display: "flex", alignItems: "center", padding: "5px", marginRight: "3px" } }, { children: [save && (_jsx(Tooltip, __assign({ arrow: true, title: "save changes" }, { children: _jsx(IconButton, __assign({ disabled: save.disable, 
                                // disabled={true}
                                id: "save-changes", sx: {
                                    borderRadius: "3px",
                                    marginRight: "4px",
                                    width: "".concat(buttonsPxSize, "px"),
                                    height: "".concat(buttonsPxSize, "px"),
                                }, onClick: function (e) {
                                    save.onSave();
                                } }, { children: _jsx(SaveRoundedIcon, {}) })) }))), cancel && (_jsx(Tooltip, __assign({ arrow: true, title: "cancel changes" }, { children: _jsx(IconButton, __assign({ disabled: cancel.disable, 
                                // disabled={true}
                                id: "cancel-changes", sx: {
                                    borderRadius: "3px",
                                    marginRight: "4px",
                                    width: "".concat(buttonsPxSize, "px"),
                                    height: "".concat(buttonsPxSize, "px"),
                                }, onClick: function (e) {
                                    cancel.onCancel();
                                } }, { children: _jsx(CancelRoundedIcon, {}) })) })))] }))] })) })));
}
